/**
 * Validates a password based on the following rules:
 * - Must be at least 8 characters
 * - Must have lowercase characters
 * - Must have uppercase characters
 * - Must have numeric characters
 * - Must have symbol characters
 *
 * @param value - The password to validate
 * @returns An error message if the password is invalid, otherwise null
 */
export const validatePassword = (value: string | undefined): string | null => {
  // If value is null or empty string, backend will generate password
  if (!value) return null

  // Otherwise, apply all password rules
  if (value.length < 8) return 'Password must be at least 8 characters'
  if (!/[a-z]/.test(value)) return 'Password must have lowercase characters'
  if (!/[A-Z]/.test(value)) return 'Password must have uppercase characters'
  if (!/[0-9]/.test(value)) return 'Password must have numeric characters'
  if (!/[!@#$%^&*]/.test(value)) return 'Password must have symbol characters'

  return null
}

export const validateEmail = (value: string | undefined): string | null => {
  if (!value) return null
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email address'
  return null
}
